import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';

import Video from '../../Video';
import styles from './styles.m.css';

const StreamerScreen = ({ streamer, containerClassName, className, onClick }) => {
  const containerRef = useRef();
  if (!streamer) {
    return null;
  }

  return (
    <>
      <button
        className={classNames(styles.container, containerClassName)}
        onClick={onClick}
        ref={containerRef}
      >
        <Video
          videoTrack={streamer.screenTrack}
          className={classNames(styles.video, className)}
        />
      </button>
    </>
  );
};

export default observer(StreamerScreen);
